<template>
  <div class="icon-content">
    <!-- 顶部图标 -->
    <img class="icon-tip" :src="appData.agentLogoUrl" />

    <!-- 宣传语 -->
    <div class="center-tip">少花钱 上好网</div>

    <!-- 设备输入区 -->
    <div class="center-content">
      <div class="center-top">
        <p>请关联设备</p>
        <img
          class="img-style"
          src="@/assets/2025/trouble.png"
          @click="showAction"
        />
      </div>

      <div class="row-box">
        <div class="left-box">
          <div class="label">设备编号</div>
          <input
            class="input-style"
            type="text"
            placeholder="请输入设备编号"
            v-model.trim="deviceSn"
            @blur="handleBlur('deviceSn', deviceSn)"
          />
        </div>

        <div class="rightScanContent">
          <img
            class="scan"
            src="@/assets/images/home/scan.png"
            alt="扫码"
            @click="enterScanAction"
          />
        </div>
      </div>
    </div>

    <!-- 提交按钮 -->
    <div class="buy-button" @click="buyAction">提交</div>

    <van-overlay :show="show" @click="closeOverlay">
      <div class="wrapper">
        <div class="block" @click.stop>
          <p class="block-tip">请扫描设备条形码进行关联</p>
          <img class="block-icon" src="@/assets/deviceCode.png" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { getWXAuthInfor, checkOtherDevice } from "@/api/home";
import { Toast } from "vant";
export default {
  data() {
    return {
      deviceSn: "", // 设备编号
      deviceID: "", // 设备ID
      modelName: "", //设备型号
      show: false,
      // isShowOther: 0, //是否展示为其他设备充值
    };
  },

  mounted() {
    // this.isShowOther = this.$route.query.isShowOther || 0;
    this.initWXConfig();
  },

  methods: {
    showAction() {
      this.show = true;
    },

    closeOverlay() {
      this.show = false;
    },

    /** 初始化微信授权配置 */
    initWXConfig() {
      getWXAuthInfor()
        .then((res) => {
          this.$wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.noncestr,
            signature: res.signature,
            jsApiList: ["scanQRCode"],
          });

          this.$wx.ready(() => {
            console.log("微信JS-SDK初始化成功");
          });

          this.$wx.error((err) => {
            console.error("wx.config 错误:", err);
          });
        })
        .catch(() => {
          this.$toast.fail("微信授权初始化失败");
        });
    },

    /** 扫码录入 */
    enterScanAction() {
      this.$wx.scanQRCode({
        needResult: 1,
        scanType: ["barCode"],
        success: (res) => {
          const resultStr = res.resultStr;
          this.deviceSn = resultStr.split(",").pop();
          this.getDeviceInfoAction();
        },
        fail: () => {
          this.$toast.fail("扫描失败");
        },
      });
    },

    /** 输入失焦处理 */
    handleBlur(field, value) {
      if (value) {
        this[field] = value;
        this.getDeviceInfoAction();
      }
    },

    /** 获取设备信息 */
    getDeviceInfoAction() {
      // checkOtherDevice({ sn: this.deviceSn }).then((res) => {
      //   if (res) {
      //     this.deviceType = res.modelName;
      //     this.deviceID = res.id;
      //     // this.skipPay = res.skipPay;
      //   } else {
      //     this.$toast.fail("查无设备，请核对设备编号！");
      //     this.deviceType = "";
      //     this.deviceID = "";
      //   }
      // });
    },

    /** 提交 */
    buyAction() {
      if (!this.deviceSn) {
        Toast.fail("请输入设备编号");
        return;
      }

      checkOtherDevice({ sn: this.deviceSn }).then((res) => {
        if (res) {
          this.uni.navigateTo(
            "/home/updateBuy?isHelpOtherPurchase=1&sn=" +
              this.deviceSn +
              "&isShowOther=0&isenterAuth=0"
          );
        } else {
          // this.$toast.fail("查无设备，请核对设备编号！");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;

  .block {
    width: 550px;
    height: 550px;
    background-color: #fff;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 1001;
    .block-tip {
      font: 32px;
      color: #1d2129;
      font-weight: bold;
    }

    .block-icon {
      width: 444px;
      height: 366px;
    }
  }
}

.icon-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding-top: 126px;
  width: 100%;
  height: 100%;

  .icon-tip {
    width: 136px;
    height: 136px;
  }

  .center-tip {
    color: #333;
    font-size: 36px;
    font-weight: bold;
    margin-top: 30px;
    text-align: center;
  }

  .center-content {
    margin: 50px 0 200px;
    background-color: #fff;
    border-radius: 16px;
    width: calc(100vw - 64px);
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .center-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 32px;
    font-weight: bold;
    color: #000;

    .img-style {
      width: 40px;
      height: 40px;
    }
  }

  .row-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // border: 1px solid var(--line-color);
    border-radius: 8px;
    padding: 12px 20px;
    box-shadow: 0 4px 8px rgba(102, 102, 102, 0.15);
    height: 85px;
    margin-bottom: 30px;

    .left-box {
      flex: 1;
      display: flex;
      align-items: center;
      min-width: 0;

      .label {
        width: 180px;
        flex-shrink: 0;
        font-size: 32px;
      }

      .input-style {
        flex: 1;
        min-width: 0;
        height: 60px;
        padding: 0 10px;
        font-size: 32px;
        border: none;
        outline: none;

        &::placeholder {
          color: #9d9d9d;
        }
      }
    }

    .rightScanContent {
      flex-shrink: 0;

      .scan {
        width: 40px;
        height: 40px;
        cursor: pointer;
      }
    }
  }

  .buy-button {
    background-color: var(--primary-color);
    color: #fff;
    font-size: 32px;
    width: calc(100vw - 80px);
    height: 90px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &.disabled {
      opacity: 0.6;
      pointer-events: none;
    }

    &:active {
      opacity: 0.9;
    }
  }
}
</style>
